import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-672f6960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "play-bar-wrapper" }
const _hoisted_2 = { class: "process" }
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = { class: "speed-drop-text" }

import {
  ref,
  computed,
  watch,
  onMounted,
} from 'vue'
import L from 'leaflet'
import { isEmpty } from 'lodash'
import { formatterKm, formatLat, formatLng } from '@/utils/map.utils'
import moment from 'moment'

import '@/utils/animatedMarker'


export default /*#__PURE__*/_defineComponent({
  __name: 'play-bar',
  props: [
  'getMap',
  'trailData',
  'isPlay',
  'playIcon',
  'speed',
],
  emits: ['exit', 'setPlayIcon', 'setSpeed'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

watch(
  () => props.isPlay,
  () => {
    if (props.isPlay) {
      // speed.value = 1
      speed.value = props.speed
      animatedMarker.value?.setSpeetX?.(props.speed)
    }
  }
)

const $emit = __emit

const speed = ref(1)
const speedLabel = computed(() => {
  return speedList.filter((item: any) => item.value === speed.value)?.[0].label
})
const speedChange = (value: number) => {
  speed.value = value
  animatedMarker.value.setSpeetX(value)
  $emit('setSpeed', value)
}

const PLAY_STATUS_ENUM = {
  UNPLAY: 'UNPLAY',
  PLAYING: 'PLAYING',
  PAUSE: 'PAUSE',
}

const playStatus = ref(PLAY_STATUS_ENUM.UNPLAY)

const start = () => {
  animatedMarker.value?.start?.()
  playStatus.value = PLAY_STATUS_ENUM.PLAYING
}

const pause = () => {
  animatedMarker.value?.pause?.()
}

const stop = () => {
  animatedMarker.value?.stop?.()
}

const speedList = [
  {
    value: 1,
    label: '1X',
  },
  {
    value: 2,
    label: '2X',
  },
  {
    value: 4,
    label: '4X',
  },
  {
    value: 16,
    label: '16X',
  },
  {
    value: 32,
    label: '32X',
  },
  {
    value: 64,
    label: '64X',
  },
  {
    value: 128,
    label: '128X',
  },
]

// 起始点
const iconEntity: any = ref({})
const drawIcon = () => {
  const { getMap, trailData } = props
  const map = getMap()

  if (trailData.length !== 0) {
    const start: any = trailData[0]
    const startMarker = L.marker([start.latitude, start.longitude], {
      icon: new L.divIcon({
        iconSize: [30, 24],
        className: 'ws_map-start-icon',
        iconAnchor: [40, 10],
      }),
    })
    startMarker.addTo(map)

    const end: any = trailData[trailData.length - 1]

    const endMarker = L.marker([end.latitude, end.longitude], {
      icon: new L.divIcon({
        iconSize: [30, 24],
        className: 'ws_map-end-icon',
        iconAnchor: [-10, 10],
      }),
    })
    endMarker.addTo(map)

    iconEntity.value = {
      startMarker,
      endMarker,
    }
  }
}
const animatedMarker: any = ref({})

const polylineEntity = ref()
const reduisEntityList: any = ref([])
const drawTrail = (deviceInfo: any) => {
  const { getMap, trailData } = props
  const map = getMap()

  drawIcon()

  const latlngs = trailData.map(({ latitude, longitude, updateTime }: any) => {
    return [latitude, longitude, updateTime]
  })

  // 只有一个点的时候
  if (trailData.length === 1) {
    map.fitBounds(latlngs)
    return
  }
  // 画线
  const polyline = L.polyline(latlngs, { color: '#4B81E5' })
  polylineEntity.value = polyline
  polyline.addTo(map)

  // 画圆点
  latlngs.map((item: any, index: number) => {
    const [latitude, longitude, updateTime] = item
    const marker = L.marker([latitude, longitude], {
      icon: new L.divIcon({
        iconSize: [8, 8],
        className: 'ws_trail_step',
        iconAnchor: [5, 5],
        zIndexOffset: 9999,
      }),
    })

    marker.addTo(map)
    const p = new L.popup({
      offset: L.point(0, -8),
    })

    const speed = getSpeed(index - 1 >= 0 ? latlngs[index - 1] : {}, item)
    p.setContent(`
        <div class='pop'>
          <p>设备名称：${deviceInfo.deviceName}</p>
          <p>节点总数：${Number(latlngs.length)}</p>
          <p>序号：${Number(index + 1)}</p>
          <p>速度：${speed}</p>
          <p>经度：${formatLng(longitude) + ' ' + longitude + '°'}</p>
          <p>纬度：${formatLat(latitude) + ' ' + latitude + '°'}</p>
          <p>采集时间：${moment(updateTime).format('YYYY-MM-DD HH:mm:ss')}</p>
        </div>
      `)
    marker.bindPopup(p)
    marker.on('click', () => {
      marker.openPopup()
    })
    reduisEntityList.value.push(marker)
  })

  const mm = L.icon({
    iconSize: [50, 62],
    iconAnchor: [25, 60],
    // iconUrl: icon,
    className: 'map-' + deviceInfo.picCode,
  })

  // 生成一个轨迹动画
  animatedMarker.value = L.animatedMarker(polyline.getLatLngs(), {
    interval: 500, // 默认为100mm
    icon: mm,
    playCall: playCall(),
    speetX: speed.value,
  }).addTo(map)

  // 获取总长度
  totalTrailM.value = getTotalTrailM(latlngs)

  map.fitBounds(latlngs)
}

// 长度
const trailM: any = ref('0')
const totalTrailM = ref('')

const percentage = computed(() => {
  return Number(
    Number((trailM.value / Number(totalTrailM.value)) * 100).toFixed(2)
  )
})

const getTotalTrailM = (latlngs: any) => {
  const { getMap } = props
  const map = getMap()
  const total = latlngs.reduce((mo: number, el: any, index: number) => {
    if (index >= latlngs.length - 1) {
      return mo
    }
    const [lat, lng] = el
    const [nextLat, nextLng] = latlngs[index + 1]
    const t = map.distance({ lat, lng }, { lat: nextLat, lng: nextLng })
    mo += Number(t.toFixed(2))
    return mo
  }, 0)
  return Number(total).toFixed(2)
}

// 轨迹进度条
const playCall = () => {
  const { getMap } = props
  const map = getMap()
  let preLatlng: any = null
  let m = 0
  return (latlngs: any, ops?: any) => {
    if (ops?.status) {
      if (ops?.status === PLAY_STATUS_ENUM.UNPLAY) {
        m = 0
        trailM.value = 0
        playStatus.value = PLAY_STATUS_ENUM.UNPLAY
        preLatlng = null
      } else if (ops?.status === PLAY_STATUS_ENUM.PAUSE) {
        playStatus.value = PLAY_STATUS_ENUM.PAUSE
      }

      return
    }
    if (isNaN(latlngs.lat)) {
      return
    }
    const { lat, lng } = latlngs
    const latlng = {
      lat: lat.toFixed(6),
      lng: lng.toFixed(6),
    }
    preLatlng && (m += Number(map.distance(preLatlng, latlng).toFixed(2)))
    preLatlng = latlng
    trailM.value = Number(m).toFixed(2)
  }
}

const getSpeed = (pre: any, now: any) => {
  const { getMap } = props
  const map = getMap()
  if (isEmpty(pre) || isEmpty(now)) {
    return ' - '
  }
  const [preLatitude, preLongitude, preUpdateTime] = pre
  const [latitude, longitude, updateTime] = now
  if (preLatitude === latitude && preLongitude === longitude) {
    return '0km/h'
  }
  if (preUpdateTime === updateTime) {
    return ' - '
  }
  const m = map.distance(
    { lat: preLatitude, lng: preLongitude },
    { lat: latitude, lng: longitude }
  )
  const km = m / 1000
  const t = updateTime - preUpdateTime
  const h = t / 3600000

  const s = (km / h).toFixed(2)
  if (isNaN(Number(s))) {
    return ' - '
  } else if (s === '0.00') {
    return '0km/h'
  }
  return s + 'km/h'
}

const removeTrail = () => {
  speed.value = 1
  polylineEntity.value?.remove?.()

  reduisEntityList.value.forEach((entity: any) => {
    entity?.remove?.()
  })
  reduisEntityList.value = []

  iconEntity.value.startMarker?.remove?.()
  iconEntity.value.endMarker?.remove?.()
  animatedMarker.value?.removeAll?.()
}

const exit = () => {
  stop()
  // speed.value = 1
  $emit('exit', false)
}

const getTrailEntity = () => {
  return [
    polylineEntity.value,
    reduisEntityList.value,
    iconEntity.value.startMarker,
    iconEntity.value.endMarker,
  ]
    .flat(Infinity)
    .filter(Boolean)
}

__expose({
  drawTrail,
  removeTrail,
  getTrailEntity,
})

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("i", {
        onClick: start,
        class: "icon play"
      }, null, 512), [
        [_vShow, 
        playStatus.value === PLAY_STATUS_ENUM.UNPLAY ||
        playStatus.value === PLAY_STATUS_ENUM.PAUSE
      ]
      ]),
      _withDirectives(_createElementVNode("i", {
        onClick: pause,
        class: "icon stop"
      }, null, 512), [
        [_vShow, playStatus.value === PLAY_STATUS_ENUM.PLAYING]
      ]),
      _createElementVNode("i", {
        onClick: stop,
        class: "icon pause"
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_progress, {
          percentage: percentage.value,
          "show-text": false
        }, null, 8, ["percentage"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatterKm)(trailM.value)) + "/" + _toDisplayString(_unref(formatterKm)(totalTrailM.value)), 1)
      ]),
      _createVNode(_component_el_dropdown, {
        onCommand: speedChange,
        class: "speed-drop",
        teleported: false,
        placement: "top"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(speedList, (item, index) => {
                return _createVNode(_component_el_dropdown_item, {
                  command: item.value,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass({ selected: item.value === speed.value })
                    }, _toDisplayString(item.label), 3)
                  ]),
                  _: 2
                }, 1032, ["command"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(speedLabel.value), 1)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, props.isPlay]
    ]),
    _withDirectives(_createVNode(_component_el_button, {
      onClick: exit,
      type: "primary",
      class: "play-out-btn"
    }, {
      default: _withCtx(() => [
        _createTextVNode("退出")
      ]),
      _: 1
    }, 512), [
      [_vShow, props.isPlay]
    ])
  ], 64))
}
}

})